import React, { useContext, useEffect, useState } from 'react'
import Headerdetails from './Headerdetails'
import MROFullScreenRightDrawer from 'components/fullwidth_dialog'
import ToolBar from 'components/ToolBar'
import { makeStyles, Typography, IconButton, Menu, MenuItem } from '@material-ui/core'
import CoreExchange from './CoreExchange'
import { getOrganisationId, getUserId } from 'lib/utils/common_utils'
import PartSalesServices from 'lib/services/api/commercial/parts'
import VerticalIcon from '@material-ui/icons/MoreVert';
import { ToastMessageContext } from 'lib/contexts/message_context'
import { WorkshopContext } from 'views/Operations/Workshop/WorkshopContext/WorkshopContext'

const useStyles = makeStyles((theme) => ({
    wrapper: {
        margin: "3%",
    },

}));


export default function ManageCoreDetails(props) {
    const { handleClose, currentSelection, permission, isInvoiceOpen } = props
    const [details, setDetails] = useState({})
    const [loading, setLoading] = useState(false)
    const classes = useStyles()
    const [anchorEl, setAnchorEl] = useState(false);
    const [open, setOpen] = useState(false)
    const message = useContext(ToastMessageContext)
    const { setSalesPaidStatus } = useContext(WorkshopContext)
    const writePermission = props?.permission?.write

    useEffect(() => {
        if (currentSelection !== undefined) {
            const fetchCorePageDetails = async () => {
                const params = {
                    organisation_id: getOrganisationId(),
                    sales_core_id: currentSelection?.id
                };

                try {
                    const response = await PartSalesServices.getCorePageDetails(params);

                    if (response) {
                        setDetails(response);
                        setSalesPaidStatus(response?.paid)
                    }
                } catch (error) {
                    console.error("Error fetching core page details:", error);
                }
            };

            fetchCorePageDetails();
        }
    }, [currentSelection]);

    const handleCloseMenu = () => {

        setOpen(false)
        setAnchorEl(false)

    }
    const handleGenerateCoreReport = async () => {

        const params = {
            organisation_id: getOrganisationId(),
            sales_order_core_id: currentSelection?.id,
            user_id: getUserId()
        }

        await PartSalesServices.getGeneratedCoreReport(params).then((res) => {
            if (res?.success) {
                message.showToastMessage({
                    message: res?.message ? res?.message : "Report sent successfully!",
                    variant: "success",
                });
            } else {
                message.showToastMessage({
                    message: res?.error ? res?.error : "Something went wrong!",
                    variant: "error",
                });
            }
            handleCloseMenu()


        }).catch((response) => {
            message.showToastMessage({
                message: response?.error ? response?.error : "Something went wrong!",
                variant: "error",
            });
        })


    }

    return (
        <MROFullScreenRightDrawer open={true}>

            <ToolBar
                handleClose={() => handleClose()}
                titleName={"Core Exchange Items"}
                loading={loading} >
                <IconButton onClick={(event) => {
                    setAnchorEl(true);
                    setOpen(true)

                }}>
                    <VerticalIcon size="small" />
                </IconButton>



            </ToolBar>
            <div className={classes.wrapper}>
                <Typography
                    color="primary"
                    style={{ marginBottom: "10px" }}>
                    Core Exchange
                </Typography>

                <Headerdetails
                    details={details}
                    loading={loading} />
                <Typography
                    color="primary"
                    style={{ marginBottom: "10px" }}>
                    Core Exchange Items
                </Typography>
                <CoreExchange
                    coreId={currentSelection?.id}
                    tab={"core"}
                    coreDetails={currentSelection}
                    permission={permission}
                    headerDetails={details}
                    isInvoiceOpen={isInvoiceOpen}
                    writePermission={writePermission}
                />

            </div>
            {open &&
                <Menu id={`long-menu`}
                    anchorEl={anchorEl}
                    // keepMounted
                    open={open}
                    className={classes.menu}
                    onClose={handleCloseMenu}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    transformOrigin={{ horizontal: "right" }}
                    PaperProps={{
                        style: {
                            maxHeight: 45 * 4.5,
                            width: "25ch",
                        },
                    }}
                >
                    <MenuItem onClick={() => {
                        handleGenerateCoreReport()
                    }}>

                        <Typography
                            style={{ paddingLeft: '2px', fontSize: 14 }} >
                            Generate Core Report
                        </Typography>
                    </MenuItem>

                </Menu >

            }
        </MROFullScreenRightDrawer>
    )
}
